import { useUrlParamModalRoute } from 'hooks/useUrlParamModalRoute';
import type { CareProgramAPIResponse, Program } from '../types';

export interface UseCareProgramModalRouteReturn {
  selectedProgram: CareProgramAPIResponse | null;
  isModalOpen: boolean;
  openProgram: (program: Program) => void;
  closeModal: () => void;
}

const getProgramId = (program: CareProgramAPIResponse) => String(program.id);

/**
 * Syncs the "selected program" detail modal with the `programId`/`topicId`
 * URL params. Used by useCareProgramsByTopic so opening/closing the modal
 * behaves identically (and is deep-linkable) across the screens that compose it.
 */
export const useCareProgramModalRoute = (
  careProgramsData: CareProgramAPIResponse[] | undefined,
): UseCareProgramModalRouteReturn => {
  const { selected, isModalOpen, open, close } = useUrlParamModalRoute({
    paramName: 'programId',
    items: careProgramsData,
    getId: getProgramId,
  });

  return {
    selectedProgram: selected,
    isModalOpen,
    openProgram: (program: Program) => open(String(program.id), { topicId: program.healthTopic }),
    closeModal: close,
  };
};
